import { useQuery } from '@tanstack/react-query';

import { fetchUsageTacking } from '@account_module/services';
import { AUDIO_PROCESSING_KEYS } from '@account_module/constants/audioProcessingKeys';

export const useAudioProcessingTracking = (params: string | null) => {
  const { data, error, isLoading } = useQuery({
    queryKey: [AUDIO_PROCESSING_KEYS.USAGE_REPORT, params],
    queryFn: () => fetchUsageTacking(params || ''),
    staleTime: 60 * 60 * 1000,
    enabled: !!params,
  });

  return { data, error, isLoading: params ? isLoading : false };
};
